import script from "./ShowActivationEventDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowActivationEventDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./ShowActivationEventDetailsModal.vue?vue&type=style&index=0&id=c72314ca&scoped=true&lang=css"
script.__scopeId = "data-v-c72314ca"

export default script